// Keep this tiny and explicit. Prefix match = section + its children.
const ROLE_ALLOWED_PREFIXES = {
  Associate: 'ALL',
  Manager: ['/leads', '/manager-mapping', '/view-tasks', '/lead-tasks', '/task-details', '/scoring-queue-dashboard', '/trends-dashboard'],
  Admin: 'ALL',
  'Super Admin': 'ALL',
  'Associate admin': 'ALL',
  'Associate Admin': 'ALL',
  User: ['/view-tasks', '/lead-tasks', '/task-details', '/leads'], // Users can now access leads to view lead details
};

const AUTH_PATHS = ['/mfa-setup', '/mfa-verify'];

const norm = (p) => (p || '').replace(/\/+$/, '');

export function canAccessPath(role, pathname) {
  // Always allow auth-related paths for any authenticated user
  if (AUTH_PATHS.some(p => pathname.startsWith(p))) {
    return true;
  }

  const rule = ROLE_ALLOWED_PREFIXES[role];
  if (!rule || rule === 'ALL') return true;

  const current = norm(pathname);
  return rule.some((prefix) => {
    const p = norm(prefix);
    return current === p || current.startsWith(p + '/');
  });
}

export function defaultRedirectForRole(role) {
  const map = {
    Associate: '/view-tasks',
    Manager: '/leads',
    Admin: '/',
    'Super Admin': '/',
    'Associate admin': '/leads',
    'Associate Admin': '/leads',
    User: '/view-tasks',
  };
  return map[role] || '/';
}
